import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import styles from './AlignBox.module.scss';

const cx = classNames.bind(styles);

const AlignBox = forwardRef(({ classArray = [], type, children, style = null, fixed = false, col = null }, ref) => {
	const data = Array.isArray(children) ? children : [children];
	const convertCol = col || data.length;
	const isEqually = type !== 'flex_auto';

	return (
		<div
			ref={ref}
			className={cx(classArray, { uifix_bottom: fixed })}
			style={style}
		>
			<div className={cx(`uialign_${type}`, 'uialign')}>
				{data.filter(Boolean).map((child, i) => {
					const key = `item${i}`;
					return (
						<div
							className={cx('uialign_item', { [`col${convertCol}`]: isEqually })}
							key={key}
						>
							{child}
						</div>
					);
				})}
			</div>
		</div>
	);
});

export default AlignBox;
